import { ThemeOptions, EvaneosThemeProvider, paletteColors } from '@evaneos/b2b-ui';

// TODO we could improves and rename the breakpoints (mobile, laptop etc.) after discussions with designer
// doc here: https://mui.com/material-ui/customization/breakpoints/
const breakpoints = {
    xs: 0,
    sm: 460,
    md: 720,
    lg: 1000,
    xl: 1200,
    xxl: 1440,
};

declare module '@evaneos/b2b-ui' {
    interface BreakpointOverrides {
        xxl: true;
    }
}

export const setTheme = (evaneosTheme: ThemeOptions): ThemeOptions => {
    return {
        ...evaneosTheme,
        breakpoints: {
            values: breakpoints,
        },
    };
};

type ToastConfig = React.ComponentProps<typeof EvaneosThemeProvider>['toastConfig'];

export const toastConfig: ToastConfig = {
    closeButton: false,
    style: {
        fontSize: '1.6rem',
        maxWidth: '380px',
        minWidth: '320px',
        // react-toastify doc for the css variables: https://fkhadra.github.io/react-toastify/how-to-style#override-css-variables
        '--toastify-font-family': 'Averta',
        '--toastify-color-success': paletteColors.green[700],
        '--toastify-color-warning': paletteColors.yellow[600],
        '--toastify-color-error': paletteColors.red[600],
        '--toastify-text-color-warning': paletteColors.neutral[900],
        '--toastify-toast-min-height': '52px',
        '--toastify-toast-width': 'auto',
        // '--toastify-toast-padding': '14px 20px 14px 14px',
    } as React.CSSProperties,
};
